import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-creditratingpage',
  templateUrl: './creditratingpage.component.html',
  styleUrls: ['./creditratingpage.component.css']
})
export class CreditratingpageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
